import { Components, Theme } from '@mui/material';

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    title: true;
    sectionTitle: true;
    heading: true;
    subTitle: true;
    defaultEmphasis: true;
    default: true;
    defaultLink: true;
    subtext: true;
    caption: true;
    drawer: true;
    field: true;
    summary: true;
    captions: true;
  }
}

export const typographyStyles: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    variant: 'default'
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      switch (ownerState.variant) {
        case 'title':
          return {
            display: 'block',
            fontWeight: '700',
            fontSize: '48px',
            lineHeight: '60px',
            letterSpacing: '-2%',
            color: theme.palette.customGrey.dark
          };
        case 'sectionTitle':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '30px',
            lineHeight: '38px',
            color: theme.palette.customGrey.dark
          };
        case 'heading':
          return {
            display: 'block',
            fontWeight: '600',
            fontSize: '20px',
            lineHeight: '30px',
            color: theme.palette.customGrey.dark
          };
        case 'subTitle':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '18px',
            lineHeight: '28px',
            color: theme.palette.customGrey.dark
          };
        case 'defaultEmphasis':
          return {
            display: 'block',
            fontWeight: '600',
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.customGrey.dark
          };
        case 'default':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.customGrey.dark
          };
        case 'defaultLink':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.primary.main,
            textDecoration: 'underline'
          };
        case 'subtext':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '20px',
            color: theme.palette.customGrey.dark
          };
        case 'caption':
          return {
            display: 'block',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '18px',
            color: theme.palette.customGrey.dark
          };
        case 'drawer':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '30px',
            lineHeight: '38px',
            color: theme.palette.customGrey.dark
          };
        case 'field':
          return {
            display: 'block',
            fontWeight: '700',
            fontSize: '18px',
            lineHeight: '26px',
            color: theme.palette.customGrey.dark
          };
        case 'summary':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '20px',
            lineHeight: '28px',
            color: theme.palette.customGrey.dark
          };
        case 'captions':
          return {
            display: 'block',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '18px',
            color: theme.palette.customGrey.dark
          };
        default:
          return {};
      }
    }
  }
};
